import auth from './auth.js';
import coaching from './coaching.js';

export default {
	auth,
	coaching
};



// WEBPACK FOOTER //
// ./src/api/index.js